/* V29: decorative shared nav underline. No navigation clicks intercepted. */
(()=>{
  const init=()=>{
    document.querySelectorAll('.vf3 .vf3-header .vf3-desktop-nav').forEach(nav=>{
      if(nav.dataset.vf29Initialized==='1')return;
      const links=Array.from(nav.querySelectorAll(':scope > a'));
      if(!links.length)return;
      nav.dataset.vf29Initialized='1';
      const glide=document.createElement('span');
      glide.className='vf29-nav-glide';
      glide.setAttribute('aria-hidden','true');
      nav.appendChild(glide);
      const active=()=>links.find(a=>a.getAttribute('aria-current')==='page');
      let selected=null;
      const update=()=>{
        const target=selected||active();
        if(!target||getComputedStyle(nav).display==='none'){
          nav.style.setProperty('--vf29-visible','0');return;
        }
        const n=nav.getBoundingClientRect(),r=target.getBoundingClientRect();
        nav.style.setProperty('--vf29-x',`${r.left-n.left+Math.min(12,r.width*.16)}px`);
        nav.style.setProperty('--vf29-w',`${Math.max(0,r.width-Math.min(24,r.width*.32))}px`);
        nav.style.setProperty('--vf29-visible','1');
      };
      links.forEach(link=>{
        link.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'||e.pointerType==='pen'){selected=link;update();}});
        link.addEventListener('focus',()=>{selected=link;update()});
      });
      nav.addEventListener('pointerleave',()=>{selected=null;update()});
      nav.addEventListener('focusout',()=>requestAnimationFrame(()=>{if(!nav.contains(document.activeElement)){selected=null;update();}}));
      window.addEventListener('resize',update,{passive:true});
      if('ResizeObserver'in window){new ResizeObserver(update).observe(nav)}
      nav.classList.add('vf29-nav-ready');
      update();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
